import { render, staticRenderFns } from "./Distributors.vue?vue&type=template&id=26cbc39d&scoped=true&"
import script from "./Distributors.vue?vue&type=script&lang=js&"
export * from "./Distributors.vue?vue&type=script&lang=js&"
import style0 from "./Distributors.vue?vue&type=style&index=0&id=26cbc39d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cbc39d",
  null
  
)

export default component.exports